import styled from 'styled-components';

// TODO pull values from theme
export const Radio = styled.span`
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  background: #ffffff;
  border: 1px solid #999;
  border-radius: 50%;
  box-shadow: none;
  color: #fff;
  cursor: pointer;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center; // Ensure horizontal alignment with label
  vertical-align: middle;

  input {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;

    &:disabled {
      cursor: not-allowed;
    }
  }

  input:checked ~ ${Radio} {
    background: ${({ theme }) => theme.brand.primary.base};
    border-color: ${({ theme }) => theme.brand.primary.base};
    box-shadow: inset 0 0 0 5px #fff;
  }

  input:focus ~ ${Radio} {
    border-color: ${({ theme }) => theme.brand.primary.base};
  }

  input:disabled ~ ${Radio} {
    background: #f2f2f2;
    border-color: #d9d9d9;
    color: #d9d9d9;
  }
`;
